import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import { CommonModalT } from './types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';

export type ConfirmModalProps = CommonModalT & {
    onConfirm: () => void;
    onCancel: () => void;
    confirmClassName?: string;
};

const ConfirmationModal = ({
    isOpen,
    title,
    text,
    children,
    width = 'sm',
    onCancel,
    onConfirm,
    confirmClassName,
}: ConfirmModalProps) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={isOpen}
            fullScreen={width === 'full-screen'}
            fullWidth
            maxWidth={width === 'full-screen' ? false : width}
        >
            <DialogTitle id="dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="dialog-description">
                    {text}
                </DialogContentText>
                <Flex padding="1rem 0" gap={1} flexDirection="column">
                    {children}
                </Flex>
            </DialogContent>
            <DialogActions id="dialog-buttons">
                <Button onClick={onCancel} variant="text">
                    {t('common.cancel')}
                </Button>
                <Button
                    onClick={onConfirm}
                    autoFocus
                    variant="contained"
                    className={confirmClassName}
                >
                    {t('common.confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationModal;
